import { useEffect, useState } from "react";
import { Quote, Star } from "lucide-react";
import api, { resolveImageUrl } from "../lib/api";
import Reveal from "./Reveal";

export default function Testimonials() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/testimonials").then((r) => setItems(r.data || [])).catch(() => {});
  }, []);

  if (items.length === 0) return null;

  return (
    <section className="py-24 lg:py-32 relative overflow-hidden" data-testid="home-testimonials">
      <div className="absolute inset-0 azure-radial" />
      <div className="absolute inset-0 flame-radial opacity-40" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-14">
          <Reveal><span className="text-xs font-bold tracking-[0.25em] text-[#3B82F6] uppercase">What clients say</span></Reveal>
          <Reveal delay={0.1}><h2 className="mt-4 text-4xl sm:text-5xl font-bold">Loved across <span className="fb-text">industries & continents</span></h2></Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.slice(0, 6).map((t, i) => (
            <Reveal key={t.id} delay={i * 0.06}>
              <div className="glass rounded-3xl p-7 h-full hover:border-[#FF6B1A]/40 transition-all relative overflow-hidden tilt-card" data-testid={`testimonial-${t.id}`}>
                <Quote className="absolute top-5 right-5 text-[#FF6B1A]/15" size={56} />
                <div className="flex gap-0.5 mb-4">
                  {[...Array(t.rating || 5)].map((_, k) => <Star key={`star-${t.id}-${k}`} size={14} className="fill-[#FFAA33] text-[#FFAA33]" />)}
                </div>
                <p className="text-zinc-200 leading-relaxed text-sm">"{t.quote}"</p>
                <div className="mt-6 flex items-center gap-3">
                  {t.photo_url ? (
                    <img src={resolveImageUrl(t.photo_url)} alt={t.name} className="w-11 h-11 rounded-full object-cover border border-[#FF6B1A]/40" />
                  ) : (
                    <div className="w-11 h-11 rounded-full bg-gradient-to-br from-[#FF6B1A] to-[#3B82F6] flex items-center justify-center font-bold text-black">
                      {t.name?.[0]}
                    </div>
                  )}
                  <div>
                    <p className="text-sm font-semibold">{t.name}</p>
                    <p className="text-xs text-zinc-500">{t.role}{t.company && ` · ${t.company}`}</p>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
